import React from 'react';
import type { Block } from '../../../types/parcours';

interface TableBlock extends Block {
  type: 'table';
  columns?: string[];
  rows?: string[][];
}

interface Props {
  block: TableBlock;
}

export default function TableBlock({ block }: Props) {
  if (!block.columns?.length || !block.rows?.length) return null;

  return (
    <div className="my-6 overflow-x-auto rounded-xl border border-neutral-200">
      <table className="w-full text-sm text-left">
        <thead className="bg-neutral-50 border-b border-neutral-200">
          <tr>
            {block.columns.map((col, idx) => (
              <th
                key={idx}
                scope="col"
                className="px-4 py-3 font-semibold text-neutral-700 whitespace-nowrap"
              >
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-neutral-100">
          {block.rows.map((row, rIdx) => (
            <tr key={rIdx} className="hover:bg-neutral-50 transition-colors">
              {row.map((cell, cIdx) => (
                <td key={cIdx} className="px-4 py-3 text-neutral-700">
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
